import messageIdMapping from "../../IdMappings/MessageIdMapping.ts";
import {v4 as uuidv4} from "uuid";
import {writeFullChat} from "./chatMessagesUtils.ts";
import {addNewChatToHistory} from "./chatMetadataUtils.ts";

export const handleSave = async (user: any, messagesSequenceRef: any, updateChatHistory: any, setDynamicStateObj: any, chatName: string = "New Chat") => {
    const newUuids: any = {};

    // Just to make sure the user never saved this sequence before, create it with new UUIDs
    const messages = Object.values(messageIdMapping).map((message: any) => {
        if (!(message.id in newUuids)) newUuids[message.id] = uuidv4();
        message.id = newUuids[message.id];

        if (message.parent) {
            if (!(message.parent in newUuids)) newUuids[message.parent] = uuidv4();
            message.parent = newUuids[message.parent];
        }

        message.children = message.children.map((child: any) => {
            if (!(child in newUuids)) newUuids[child] = uuidv4();
            child = newUuids[child];

            return child;
        });

        return message;
    });


    const conversationId = uuidv4();
    await writeFullChat(user, conversationId, messagesSequenceRef, messages);
    addNewChatToHistory(chatName, false, updateChatHistory, conversationId, user);
    setDynamicStateObj({visiblePopup: null});
};
